import * as R from 'remeda';

import { LoadingAction, LoadingState } from '.';

const initialState: LoadingState = {
  'glue/user/START_LOGIN': { status: 'idle' },
  'glue/user/START_VERIFY': { status: 'idle' },
  'glue/user/START_LOGOUT': { status: 'idle' },
  'glue/app/START_INITIALIZE': { status: 'loading' },
  'page/flexHours/START_SELECT_DATES': { status: 'idle' },
  'page/productivity/START_TOGGLE_HOURS': { status: 'idle' },
  'page/integrations/START_FETCH_PAGE': { status: 'idle' },
  'page/forecast/START_CREATE_FORECAST': { status: 'idle' },
  'page/integrations/START_UPLOAD_FILE': { status: 'idle' },
  'page/improvements/START_SAVE_SUGGESTION': { status: 'idle' },
  'page/zoneManagement/START_UPDATE_SUB_ZONES': { status: 'idle' },
  'page/improvements/START_CREATE_MOCK_SUGGESTION': { status: 'idle' },
  'page/improvements/START_CREATE_ACTION_FROM_SUGGESTION': { status: 'idle' },
  'page/improvements/START_REJECT_SUGGESTION': { status: 'idle' },
  'page/improvements/START_DELETE_SUGGESTION': { status: 'idle' },
  'page/improvements/START_UPDATE_ACTION': { status: 'idle' },
  'page/improvements/START_DELETE_ACTION': { status: 'idle' },
  'page/improvements/START_CREATE_MOCK_ACTION': { status: 'idle' },
  'page/improvements/START_ADD_ACTION': { status: 'idle' },
  'page/forecast/START_FORECAST_WEEK': { status: 'idle' },
  'page/realtime/START_SELECT_DAY': { status: 'idle' },
};

const loadingReducer = (
  state: LoadingState = initialState,
  action: LoadingAction,
): LoadingState => {
  switch (action.type) {
    case 'glue/loading/UPDATE_LOADING_STATUS': {
      const { status, type, error } = action.payload;

      const updatedLoadingStatus = R.pipe(
        state,
        R.prop(type),
        R.set('status', status),
        R.set('error', error),
      );

      return R.set(state, type, updatedLoadingStatus);
    }
    default:
      return state;
  }
};

export default loadingReducer;
